import axios from "axios";
import swal from "sweetalert2";

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { globalState, accessTokenKey, baseUrl } from "../utils/config";

import SingleJob from "./layouts/SingleJob";
import Loader from "./layouts/Loader";

function MyJobs() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [jobs, setJobs] = useState([]);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    
    async function fetch() {
        setLoading(true);
        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

            const formData = new FormData();
            formData.append("page", page);
            formData.append("time_zone", timeZone);
            formData.append("search", search);

            const response = await axios.post(
                baseUrl + "/api/jobs/my",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setJobs(response.data.jobs);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoading(false);
        }
    }

    function deleteJob(id, title) {
        swal.fire({
            title: "Delete job: '" + title + "'",
            text: "Are you sure you want to delete this job ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async function (result) {
            if (result.isConfirmed) {
                try {
                    const formData = new FormData()
                    formData.append("id", id)

                    const response = await axios.post(
                        baseUrl + "/api/jobs/delete",
                        formData,
                        {
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                            }
                        }
                    );

                    if (response.data.status == "success") {
                        const temp = [...jobs]
                        for (let a = 0; a < temp.length; a++) {
                            if (temp[a].id == id) {
                                temp.splice(a, 1)
                            }
                        }
                        setJobs(temp)
                    } else {
                        swal.fire("Error", response.data.message, "error")
                    }
                } catch (exp) {
                    swal.fire("Error", exp.message, "error")
                }
            }
        });
    }

    useEffect(function () {
        fetch();
    }, []);

    const styles = {
        state: {
            color: "white",
            padding: "5px 10px",
            borderRadius: "5px"
        }
    };

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">My Jobs</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/jobs">Jobs</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">My</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">My Jobs</h1>
                    
                    <div className="tab-class text-center wow fadeInUp" data-wow-delay="0.3s">

                        <div className="row mb-5">
                            <div className="offset-md-3 col-md-5">
                                <input type="text" className="form-control" placeholder="Search..."
                                    value={ search }
                                    onChange={ function (event) {
                                        setSearch(event.target.value || "");
                                    } }
                                    onKeyDown={ function (event) {
                                        if (event.key === "Enter") {
                                            fetch();
                                        }
                                    } } />
                            </div>

                            <div className="col-md-1">
                                <button type="button" className="btn btn-primary"
                                    onClick={ function () {
                                        fetch();
                                    } }
                                    disabled={ loading }>Search</button>
                            </div>
                        </div>

                        { loading && (
                            <div className="row mb-5">
                                <div className="col-md-12">
                                    <Loader />
                                </div>
                            </div>
                        ) }

                        <div className="row">
                            <div className="col-md-12">
                                <table className="table table-bordered table-responsive">
                                    <thead>
                                        <tr>
                                            <th>Title</th>
                                            <th>Category</th>
                                            <th>Type</th>
                                            <th>Nature</th>
                                            <th>Salary</th>
                                            <th>Vacancies</th>
                                            <th>Status</th>
                                            <th>Applicants</th>
                                            <th>State</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        { jobs.map(function (j, index) {
                                            return (
                                                <tr key={ `job-${ j.id }` }>
                                                    <td>
                                                        <Link to={ `/jobs/${ j.id }` }>{ j.title }</Link>

                                                        <br />

                                                        <i className="fa fa-eye"></i>&nbsp;
                                                        { j.views }
                                                    </td>
                                                    <td>{ j.category }</td>
                                                    <td>
                                                        <p>{ j.type.split("_").join(" ").toUpperCase() }</p>

                                                        { j.location && (
                                                            <p>{ j.location }</p>
                                                        ) }
                                                    </td>
                                                    <td>{ j.nature.split("_").join(" ").toUpperCase() }</td>
                                                    <td>{ `${ j.currency } ${ j.salary_from } - ${ j.salary_to }` }</td>
                                                    <td>{ j.vacancies }</td>
                                                    
                                                    <td>
                                                        { j.status == "active" ? (
                                                            <b className="bg-success"
                                                                style={ styles.state }>Active</b>
                                                        ) : j.status == "in_active" && (
                                                            <b className="bg-warning"
                                                                style={ styles.state }>Inactive</b>
                                                        ) }
                                                    </td>
                                                    
                                                    <td>{ j.applicants }</td>
                                                    <td>
                                                        { j.state == "pending" ? (
                                                            <b className="bg-warning"
                                                                style={ styles.state }>Pending</b>
                                                        ) : j.state == "approved" ? (
                                                            <b className="bg-success"
                                                                style={ styles.state }>Approved</b>
                                                        ) : j.state == "cancelled" && (
                                                            <b className="bg-danger"
                                                                style={ styles.state }>Cancelled</b>
                                                        ) }
                                                    </td>
                                                    <td>
                                                        <Link className="btn btn-warning"
                                                            to={ `/jobs/${ j.id }/edit` }>Edit</Link>&nbsp;

                                                        <button type="button" className="btn btn-danger" onClick={ function () {
                                                            deleteJob(j.id, j.title);
                                                        } }>Delete</button>
                                                    </td>
                                                </tr>
                                            );
                                        }) }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MyJobs;